import { axiosInstance } from "@/use/utilities/axios/app/axios-instance";

export async function fetchProjects(action, id, date = null, onlyDates = false, filters = {}) {
  const axios = axiosInstance().primoLab;

  try {
    const response = await axios.get(`/projects`, {
      params: {
        action,
        id,
        date,
        only_dates: onlyDates,
        ...filters,
      },
    });

    const { projects = [], dates = [], count, message } = response.data.data;

    return {
      projects,
      dates,
      count,
      message,
    };
  } catch (error) {
    const errorMessages = error.response?.data?.errors || ['Si è verificato un errore imprevisto'];
    throw new Error(errorMessages.join(', '));
  }
}